module.exports = __webpack_public_path__ + "static/media/JavaScriptIcon.228560f3.svg";